/**
 * @flow
 */

/* eslint-disable */

'use strict';


/*::
import type { ConcreteRequest } from 'relay-runtime';
type Layout_pageWithData$ref = any;
type Layout_root$ref = any;
type PageMeta_root$ref = any;
export type loginQueryVariables = {|
  uid: string,
  lang: string,
|};
export type loginQueryResponse = {|
  +cms: {|
    +pageWithData: ?{|
      +$fragmentRefs: Layout_pageWithData$ref
    |}
  |},
  +$fragmentRefs: Layout_root$ref & PageMeta_root$ref,
|};
export type loginQuery = {|
  variables: loginQueryVariables,
  response: loginQueryResponse,
|};
*/


/*
query loginQuery(
  $uid: String!
  $lang: String!
) {
  ...Layout_root_3iqx2P
  ...PageMeta_root
  cms {
    pageWithData(uid: $uid, lang: $lang) {
      ...Layout_pageWithData
    }
  }
}

fragment Breadcrumbs_hierarchy on CMSPage {
  template
  link_title
  custom_path
  _meta {
    uid
  }
}

fragment Layout_pageWithData on CMSPageWithData {
  hierarchy {
    ...Breadcrumbs_hierarchy
  }
  page {
    template
    canonical_url {
      __typename
      ... on CMS_ExternalLink {
        url
      }
      ... on CMSPage {
        _meta {
          uid
          lang
        }
      }
    }
    meta_robots
    show_phone
    _meta {
      id
      lang
      alternateLanguages {
        uid
        lang
        id
      }
    }
  }
}

fragment Layout_root_3iqx2P on Query {
  cms {
    navigation(uid: "main", lang: $lang) {
      nav_logo_link {
        __typename
        ... on CMSPage {
          template
          _meta {
            uid
            lang
          }
        }
      }
      phone_number
      body {
        __typename
        ... on CMSNavigationBodyNavigation_item {
          primary {
            label
            pathname
            nav_link {
              __typename
              ... on CMSPage {
                template
                _meta {
                  id
                  uid
                  lang
                }
              }
            }
          }
          fields {
            label
            pathname
            sub_nav_link {
              __typename
              ... on CMSPage {
                template
                _meta {
                  uid
                  lang
                }
              }
            }
          }
        }
      }
    }
    footerNavigation: navigation(uid: "footer", lang: $lang) {
      phone_number
    }
  }
}

fragment PageMeta_root on Query {
  cms {
    pageWithData(uid: $uid, lang: $lang) {
      page {
        title
        description
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "lang"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "uid"
},
v2 = {
  "kind": "Variable",
  "name": "lang",
  "variableName": "lang"
},
v3 = [
  (v2/*: any*/),
  {
    "kind": "Variable",
    "name": "uid",
    "variableName": "uid"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "template",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "uid",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lang",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "CMSMeta",
  "kind": "LinkedField",
  "name": "_meta",
  "plural": false,
  "selections": [
    (v6/*: any*/),
    (v7/*: any*/)
  ],
  "storageKey": null
},
v9 = [
  (v4/*: any*/),
  {
    "kind": "InlineFragment",
    "selections": [
      (v5/*: any*/),
      (v8/*: any*/)
    ],
    "type": "CMSPage",
    "abstractKey": null
  }
],
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "phone_number",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "label",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pathname",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "loginQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "CMS",
        "kind": "LinkedField",
        "name": "cms",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v3/*: any*/),
            "concreteType": "CMSPageWithData",
            "kind": "LinkedField",
            "name": "pageWithData",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "Layout_pageWithData"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "args": [
          (v2/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "Layout_root"
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "PageMeta_root"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "loginQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "CMS",
        "kind": "LinkedField",
        "name": "cms",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": [
              (v2/*: any*/),
              {
                "kind": "Literal",
                "name": "uid",
                "value": "main"
              }
            ],
            "concreteType": "CMSNavigation",
            "kind": "LinkedField",
            "name": "navigation",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "nav_logo_link",
                "plural": false,
                "selections": (v9/*: any*/),
                "storageKey": null
              },
              (v10/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "body",
                "plural": true,
                "selections": [
                  (v4/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "CMSNavigationBodyNavigation_itemPrimary",
                        "kind": "LinkedField",
                        "name": "primary",
                        "plural": false,
                        "selections": [
                          (v11/*: any*/),
                          (v12/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "nav_link",
                            "plural": false,
                            "selections": [
                              (v4/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v5/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "CMSMeta",
                                    "kind": "LinkedField",
                                    "name": "_meta",
                                    "plural": false,
                                    "selections": [
                                      (v13/*: any*/),
                                      (v6/*: any*/),
                                      (v7/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "type": "CMSPage",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "CMSNavigationBodyNavigation_itemFields",
                        "kind": "LinkedField",
                        "name": "fields",
                        "plural": true,
                        "selections": [
                          (v11/*: any*/),
                          (v12/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "sub_nav_link",
                            "plural": false,
                            "selections": (v9/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "CMSNavigationBodyNavigation_item",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": "footerNavigation",
            "args": [
              (v2/*: any*/),
              {
                "kind": "Literal",
                "name": "uid",
                "value": "footer"
              }
            ],
            "concreteType": "CMSNavigation",
            "kind": "LinkedField",
            "name": "navigation",
            "plural": false,
            "selections": [
              (v10/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v3/*: any*/),
            "concreteType": "CMSPageWithData",
            "kind": "LinkedField",
            "name": "pageWithData",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "CMSPage",
                "kind": "LinkedField",
                "name": "page",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "title",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "description",
                    "storageKey": null
                  },
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "canonical_url",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "url",
                            "storageKey": null
                          }
                        ],
                        "type": "CMS_ExternalLink",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v8/*: any*/)
                        ],
                        "type": "CMSPage",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "meta_robots",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "show_phone",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CMSMeta",
                    "kind": "LinkedField",
                    "name": "_meta",
                    "plural": false,
                    "selections": [
                      (v13/*: any*/),
                      (v7/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "CMSRelatedDocument",
                        "kind": "LinkedField",
                        "name": "alternateLanguages",
                        "plural": true,
                        "selections": [
                          (v6/*: any*/),
                          (v7/*: any*/),
                          (v13/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "CMSPage",
                "kind": "LinkedField",
                "name": "hierarchy",
                "plural": true,
                "selections": [
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "link_title",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "custom_path",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CMSMeta",
                    "kind": "LinkedField",
                    "name": "_meta",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "1a6d20b09300b26b834267dd2ccac261",
    "id": null,
    "metadata": {},
    "name": "loginQuery",
    "operationKind": "query",
    "text": "query loginQuery(\n  $uid: String!\n  $lang: String!\n) {\n  ...Layout_root_3iqx2P\n  ...PageMeta_root\n  cms {\n    pageWithData(uid: $uid, lang: $lang) {\n      ...Layout_pageWithData\n    }\n  }\n}\n\nfragment Breadcrumbs_hierarchy on CMSPage {\n  template\n  link_title\n  custom_path\n  _meta {\n    uid\n  }\n}\n\nfragment Layout_pageWithData on CMSPageWithData {\n  hierarchy {\n    ...Breadcrumbs_hierarchy\n  }\n  page {\n    template\n    canonical_url {\n      __typename\n      ... on CMS_ExternalLink {\n        url\n      }\n      ... on CMSPage {\n        _meta {\n          uid\n          lang\n        }\n      }\n    }\n    meta_robots\n    show_phone\n    _meta {\n      id\n      lang\n      alternateLanguages {\n        uid\n        lang\n        id\n      }\n    }\n  }\n}\n\nfragment Layout_root_3iqx2P on Query {\n  cms {\n    navigation(uid: \"main\", lang: $lang) {\n      nav_logo_link {\n        __typename\n        ... on CMSPage {\n          template\n          _meta {\n            uid\n            lang\n          }\n        }\n      }\n      phone_number\n      body {\n        __typename\n        ... on CMSNavigationBodyNavigation_item {\n          primary {\n            label\n            pathname\n            nav_link {\n              __typename\n              ... on CMSPage {\n                template\n                _meta {\n                  id\n                  uid\n                  lang\n                }\n              }\n            }\n          }\n          fields {\n            label\n            pathname\n            sub_nav_link {\n              __typename\n              ... on CMSPage {\n                template\n                _meta {\n                  uid\n                  lang\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n    footerNavigation: navigation(uid: \"footer\", lang: $lang) {\n      phone_number\n    }\n  }\n}\n\nfragment PageMeta_root on Query {\n  cms {\n    pageWithData(uid: $uid, lang: $lang) {\n      page {\n        title\n        description\n      }\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '5972420c39dbfff714175a0ed9883126';

export default node;
